"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasBboxHighlightFace = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
exports.CanvasBboxHighlightFace = (0, react_1.memo)(function (_a) {
    var bboxStyle = _a.bboxStyle, canvasSize = _a.canvasSize, bboxCurr = _a.highlightedBbox;
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    var bboxPrev = (0, utils_1.usePrevious)(bboxCurr);
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        window.requestAnimationFrame(function () {
            if (bboxPrev !== undefined) {
                var _a = bboxPrev.rect, top_1 = _a.top, left = _a.left, width = _a.width, height = _a.height;
                context.clearRect(left, top_1, width, height);
            }
            if (bboxCurr !== undefined) {
                var h = bboxCurr.label.hue;
                var _b = tslib_1.__read(bboxStyle.highlightedFaceColorSLA, 3), s = _b[0], l = _b[1], a = _b[2];
                var _c = bboxCurr.rect, top_2 = _c.top, left = _c.left, width = _c.width, height = _c.height;
                context.fillStyle = (0, utils_1.hslaToStr)([h, s, l, a]);
                context.fillRect(left, top_2, width, height);
            }
        });
    }, [context, bboxPrev, bboxCurr, bboxStyle.highlightedFaceColorSLA]);
    return (react_1.default.createElement("canvas", { ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasBboxHighlightFace.displayName = 'CanvasBboxHighlightFace';
